import React, { Component } from "react";
import FormElement from "../../forms/form_element";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { Grid, Row, Col } from "react-bootstrap";
import LoadingButton from "../../forms/loading_button/loading_button";
import FileUploadV2 from "../../forms/file_upload/file_upload_v2";
import { Button } from "react-bootstrap";
import Checkbox from "../../forms/checkbox";
import DateTimePicker from "react-widgets/lib/DateTimePicker";
import "../shows/show-form.scss";
import QuillEditor from "../../forms/quill";
import { seedcastForm } from "../../../lib/forms";
import { connect } from "react-redux";
import "react-quill/dist/quill.snow.css";
import get from "lodash/get";
import ImageUploader from "../../forms/image_uploader/image_uploader";
import FormDropDown from "../../lib/form_dropdown";
import { CATEGORIES, ACTIONS, gtagEvent } from "../../../lib/google_analytics";
import { If } from "react-extras";

const validateMp3Size = field => {
  if (field && field[0].size > 2 * 10 ** 8) {
    return "Your audio file is too large. RedCircle's max audio file size is 200 MB.";
  }
};

class EpisodeForm extends Component {
  onFieldChange = () => {
    gtagEvent(ACTIONS.FILL, CATEGORIES.EPISODE_FORM);
  };

  onSubmit = (...args) => {
    gtagEvent(ACTIONS.SUBMIT, CATEGORIES.EPISODE_FORM);

    this.props.handleSubmit(...args);
  };

  render() {
    const renderDateTimePicker = ({ onChange, value }) => {
      return (
        <div>
          <DateTimePicker
            onChange={onChange}
            time={true}
            value={!value ? new Date() : new Date(value)}
            step={5}
          />
        </div>
      );
    };

    var isCreateForm = this.props.mode === "create";
    return (
      <form onSubmit={this.onSubmit} className={"show-form-container"}>
        <div className={"episode-form episode-" + this.props.mode + "-form"}>
          <Grid fluid>
            <Row>
              <Col md={3} mdOffset={1}>
                <div>
                  <Field
                    component={FormElement}
                    InputComponent={ImageUploader}
                    label="Episode Artwork"
                    name="imageFile"
                    onUpload={() => gtagEvent(ACTIONS.UPLOAD, CATEGORIES.EPISODE_IMAGE)}
                    setImageFileData={(mode, file) => this.props.setImageFileData(mode, file)}
                    setImageFileUUID={this.props.setImageFileUUID}
                    mediaFileUUID={get(this.props, "initialValues.imageMediaFileUUID")}
                    setError={this.props.setError}
                    mediaFiles={this.props.mediaFiles}
                    validationErrors={this.props.validationErrors}
                    validationErrorKeyOverride={"imageMediaFileUUID"}
                  />
                </div>
              </Col>
              <Col md={6} mdOffset={1}>
                <div>
                  <Field component="input" name="showUUID" type="hidden" />
                </div>
                <div>
                  <Field
                    validate={validateMp3Size}
                    component={FormElement}
                    InputComponent={FileUploadV2}
                    label="Upload MP3"
                    name="contentFile"
                    onChange={(...args) => {
                      gtagEvent(ACTIONS.UPLOAD, CATEGORIES.EPISODE_AUDIO);
                      this.props.setAudioFileData(...args);
                    }}
                    setAudioFileData={this.props.setAudioFileData}
                    mediaFiles={this.props.mediaFiles}
                    mediaFileUUID={
                      this.props.selectedContentMediaFileUUID ||
                      get(this.props, "initialValues.contentMediaFileUUID")
                    }
                    validationErrors={this.props.validationErrors}
                    validationErrorKeyOverride={"contentMediaFileUUID"}
                  />
                </div>
                <div>
                  <Field
                    component={FormElement}
                    onChange={this.onFieldChange}
                    name="title"
                    label="Title"
                    type="text"
                    validationErrors={this.props.validationErrors}
                  />
                </div>
                <div className={"episode-form__quill-container"}>
                  <Field
                    component={FormElement}
                    onChange={this.onFieldChange}
                    InputComponent={QuillEditor}
                    name="description"
                    label="Description"
                    validationErrors={this.props.validationErrors}
                  />
                </div>

                <div>
                  <Field
                    name="publishedAt"
                    component={FormElement}
                    onChange={this.onFieldChange}
                    InputComponent={renderDateTimePicker}
                    valueField="value"
                    label="Publish Date"
                  />
                </div>
                <div>
                  <Field
                    component={FormElement}
                    onChange={this.onFieldChange}
                    InputComponent={Checkbox}
                    name="isVisible"
                    label="Draft Status"
                    checkboxLabel="Save As Draft"
                    type="checkbox"
                    validationErrors={this.props.validationErrors}
                  />
                </div>
                <If
                  condition={
                    get(this.props.show, ["youtubeAuthToken"]) &&
                    !this.props.selectedIsVisible &&
                    isCreateForm
                  }>
                  <Field
                    component={FormElement}
                    onChange={this.onFieldChange}
                    InputComponent={Checkbox}
                    name="shouldPublishToYoutube"
                    label="Publish To"
                    checkboxLabel="YouTube"
                    type="checkbox"
                    validationErrors={this.props.validationErrors}
                  />
                </If>
                <If condition={get(this.props.show, ["subscriptionDetails", "amount"])}>
                  <div>
                    <Field
                      component={FormElement}
                      onChange={this.onFieldChange}
                      InputComponent={Checkbox}
                      name="shouldPublishToSubscribers"
                      label="Exclusive Access"
                      checkboxLabel="Publish to Exclusive Feed"
                      type="checkbox"
                      validationErrors={this.props.validationErrors}
                      validationErrorKeyOverride={"shouldPublishToNonSubscribers"}
                      validationErrorMessageOverride=""
                    />
                    <Field
                      component={FormElement}
                      onChange={this.onFieldChange}
                      InputComponent={Checkbox}
                      name="shouldPublishToNonSubscribers"
                      checkboxLabel="Publish to Public Feed"
                      type="checkbox"
                      validationErrors={this.props.validationErrors}
                    />
                  </div>
                </If>
                <FormDropDown validationErrors={this.props.validationErrors}>
                  <div>
                    <Field
                      component={FormElement}
                      onChange={this.onFieldChange}
                      name="subtitle"
                      label="Subtitle"
                      type="text"
                      validationErrors={this.props.validationErrors}
                    />
                  </div>
                  <div>
                    <Field
                      component={FormElement}
                      onChange={this.onFieldChange}
                      name="link"
                      label="External Website"
                      type="text"
                      validationErrors={this.props.validationErrors}
                      infoText="A link to the episode on your external webpage. Defaults to your RedCircle podcast page."
                    />
                  </div>
                  <If
                    condition={
                      this.props.user.userAttributes.shouldSeeSeparateITunesTitle === "true"
                    }>
                    <div>
                      <Field
                        component={FormElement}
                        onChange={this.onFieldChange}
                        name="iTunesTitle"
                        label="Apple: Title"
                        type="text"
                        infoText="If you want to use a separate title within Apple Podcasts, you can specify an alternative title here."
                        validationErrors={this.props.validationErrors}
                      />
                    </div>
                  </If>
                  <div>
                    <Field
                      component={FormElement}
                      onChange={this.onFieldChange}
                      componentClass="textarea"
                      name="summary"
                      infoText="If left blank we will default to description.<br> This will be used for apps that don't support an html description like Apple Podcasts."
                      label="Apple: Summary"
                      type="textarea"
                      rows="10"
                      validationErrors={this.props.validationErrors}
                    />
                  </div>
                  <div>
                    <Field
                      component={FormElement}
                      onChange={this.onFieldChange}
                      name="episodeNumber"
                      label="Episode Number"
                      type="number"
                      validationErrors={this.props.validationErrors}
                    />
                  </div>
                  <div>
                    <Field
                      component={FormElement}
                      onChange={this.onFieldChange}
                      name="season"
                      label="Season"
                      type="number"
                      validationErrors={this.props.validationErrors}
                    />
                  </div>
                  <div>
                    <Field
                      component={FormElement}
                      onChange={() => {
                        this.onFieldChange();
                      }}
                      name="episodeType"
                      label="Episode Type"
                      type="select"
                      componentClass="select"
                      placeholder="Select a type"
                      validationErrors={this.props.validationErrors}>
                      <>
                        <option key="full" value="full">
                          Full
                        </option>
                        ,
                        <option key="trailer" value="trailer">
                          Trailer
                        </option>
                        ,
                        <option key="bonus" value="bonus">
                          Bonus
                        </option>
                      </>
                    </Field>
                  </div>
                  <div>
                    <Field
                      component={FormElement}
                      onChange={this.onFieldChange}
                      InputComponent={Checkbox}
                      name="isExplicit"
                      checkboxLabel="Episode is Explicit"
                      type="checkbox"
                      validationErrors={this.props.validationErrors}
                    />
                  </div>
                  <div>
                    <input name="isClosedCaptioned" type="hidden" value={true} />
                  </div>
                  <div>
                    <Field component="input" type="hidden" name="imageMediaFileUUID" />
                  </div>
                  <div>
                    <Field component="input" type="hidden" name="contentMediaFileUUID" />
                  </div>
                  {isCreateForm && (
                    <div>
                      <Field component="input" name="adPlacements[0]" type="hidden" value={0} />
                      <Field component="input" name="adPlacements[1]" type="hidden" value={0} />
                    </div>
                  )}
                </FormDropDown>
              </Col>
            </Row>
          </Grid>
        </div>
        <div className="episode-form__footer">
          <Grid fluid>
            <Row>
              <Col xs={6} md={5} mdOffset={1}>
                <Button
                  onClick={this.props.close}
                  className="episode-form__cancel-button episode-form__submit-button btn btn-secondary">
                  Cancel
                </Button>
              </Col>
              <Col xs={6} md={5}>
                <LoadingButton
                  isLoading={this.props.isFormLoading}
                  className="episode-form__submit-button btn btn-primary"
                  type="submit"
                  progress={this.props.progress}>
                  {this.saveButtonText()}
                </LoadingButton>
              </Col>
            </Row>
          </Grid>
        </div>
      </form>
    );
  }

  saveButtonText = () => {
    let baseWord = this.props.mode === "create" ? "Create" : "Save";
    return baseWord;
  };
}

export var EpisodeCreateForm = props => <EpisodeForm {...props} mode="create" />;

export var EpisodeEditForm = props => <EpisodeForm {...props} mode="edit" />;

var formValueSelectorCreate = formValueSelector("episode-create");
EpisodeCreateForm = connect(state => {
  return {
    selectedImageMediaFileUUID: formValueSelectorCreate(state, "imageMediaFileUUID"),
    selectedContentMediaFileUUID: formValueSelectorCreate(state, "contentMediaFileUUID"),
    selectedIsVisible: formValueSelectorCreate(state, "isVisible"),
  };
})(EpisodeCreateForm);

// formWhiteList stops the seedcastForm from stripping the value on submit
const formWhiteList = ["imageFileData", "audioFileData"];

EpisodeCreateForm = reduxForm({
  form: "episode-create",
})(EpisodeCreateForm);
EpisodeCreateForm = seedcastForm(EpisodeCreateForm, {
  whiteList: formWhiteList,
});

var formValueSelectorEdit = formValueSelector("episode-edit");
EpisodeEditForm = connect(state => {
  return {
    selectedImageMediaFileUUID: formValueSelectorEdit(state, "imageMediaFileUUID"),
    selectedContentMediaFileUUID: formValueSelectorEdit(state, "contentMediaFileUUID"),
    selectedIsVisible: formValueSelectorCreate(state, "isVisible"),
    imageUplaoder: state.imageUploader,
  };
})(EpisodeEditForm);
EpisodeEditForm = reduxForm({
  form: "episode-edit",
})(EpisodeEditForm);
EpisodeEditForm = seedcastForm(EpisodeEditForm, {
  whiteList: formWhiteList,
});
